import template from './loansDetailHeader.html';
import './loansDetailHeader.scss';

let loansCatalogDetailHeaderComponent = {
  restrict: 'E',
  bindings: {
    loan: '<',
    hideSignup: '<',
    onNavigate: '&',
    isMobileApp: '<',
  },
  template,
};

export default loansCatalogDetailHeaderComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailHeader/loansDetailHeader.component.js